import { render, staticRenderFns } from "./AssistantTabLinks.vue?vue&type=template&id=00d03a60"
import script from "./AssistantTabLinks.vue?vue&type=script&lang=js"
export * from "./AssistantTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports